import { useSelector } from "react-redux";

// Fleet Reports capability (2026-07-14): one source of truth for whether the
// current tenant has the license-gated Fleet KPI dashboard, read from
// metaData.fleetKpi (populated at app load from GET /aggregation/fleet-config).
//
// TRI-STATE — unlike useAnalyticsModes there is deliberately NO fallback:
// falling back to enabled would leak the page to every tenant; falling back to
// disabled would break the deep link while the config is still loading.
//   metaData.fleetKpi === null  → { loading:true,  enabled:false }  (not loaded yet)
//   { enabled:false }           → { loading:false, enabled:false }  (feature off)
//   { enabled:true, ... }       → { loading:false, enabled:true, …config }
const useFleetKpiConfig = () => {
  const cfg = useSelector((state) => state.metaData && state.metaData.fleetKpi);
  if (!cfg) {
    return {
      loading: true,
      enabled: false,
      vehicles: [],
      metrics: [],
      pendingMetrics: [],
      granularities: [],
      defaultWindow: null,
      currentWindow: null,
      serviceName: null,
      earliestAvailable: null,
      // Settings-page fields: keep the loading shape total so a consumer mounted
      // during load can never crash on a missing array/field.
      fuelCostEnabled: false,
      fuelPrice: null,
      fuelCurrency: "USD",
      availableVehicles: [],
      excludedVehicles: [],
      vehicleSelectionEditable: true,
      maxWindowDays: 31,
    };
  }
  return {
    loading: false,
    enabled: cfg.enabled === true,
    timezone: cfg.timezone || "America/Grenada",
    weekStartsOn: cfg.weekStartsOn === undefined ? 1 : cfg.weekStartsOn,
    // Server-computed trailing COMPLETE week in the tenant's zone. The FE must
    // not compute this: a browser in another timezone would pick a different week.
    defaultWindow: cfg.defaultWindow || null,
    // The in-progress week (week-start through today, tenant zone) - the
    // picker's "This week so far" option.
    currentWindow: cfg.currentWindow || null,
    // Display name of the fleet service (the id never crosses the wire), and the
    // real TTL horizon the week picker must bound itself on.
    serviceName: cfg.serviceName || null,
    earliestAvailable: cfg.earliestAvailable || null,
    vehicles: cfg.vehicles || [],
    metrics: cfg.metrics || [],
    pendingMetrics: cfg.pendingMetrics || [],
    granularities: cfg.granularities || ["day", "week"],
    geofenceEnabled: cfg.geofenceEnabled === true,
    // Fuel-cost (P3) + dashboard settings (2026-07-23): current price/currency
    // and the vehicle-selection state for the Settings page.
    fuelCostEnabled: cfg.fuelCostEnabled === true,
    fuelPrice: typeof cfg.fuelPrice === "number" ? cfg.fuelPrice : null,
    fuelCurrency: cfg.fuelCurrency || "USD",
    availableVehicles: cfg.availableVehicles || cfg.vehicles || [],
    excludedVehicles: cfg.excludedVehicles || [],
    vehicleSelectionEditable: cfg.vehicleSelectionEditable !== false,
    maxWindowDays: cfg.maxWindowDays || 31,
  };
};

export default useFleetKpiConfig;
